import { useQuery } from "@tanstack/react-query";
import { API_ROUTES } from "../../constants";
import { apiClient } from "./apiClient";
import { QUERY_KEYS } from "./constants";
import type { ChatSession } from "./types";

/**
 * Hook to fetch historic chat sessions for the current user
 */
export const useGetSessions = () => {
  return useQuery({
    queryKey: QUERY_KEYS.getSessions,
    queryFn: async () => {
      const response = await apiClient.get<{ chats: ChatSession[] }>(
        API_ROUTES.omniSearch.chats
      );
      return (
        response.data.chats
          .filter((session) => session.agent_name === "pulse") // Filter for Pulse agent sessions
          // Sort by created_at (newest first)
          .sort((firstItem, secondItem) => {
            return (
              new Date(secondItem.created_at).getTime() -
              new Date(firstItem.created_at).getTime()
            );
          })
          // Get the first 5 items (5 most recent sessions)
          .slice(0, 5)
      );
    },
  });
};
